// The checkout tab remembers the signup link that opened it, so the success
// page Stripe sends it back to can prove it is that tab if it has to be signed
// back in. The session_id in Stripe's return URL is not enough on its own.
// sessionStorage keeps this to the one tab and out of every URL.
export const SIGNUP_CHECKOUT_STORAGE_KEY = 'haastia.signup.checkout';

export const storeSignupCheckout = ({ sessionId, pendingSignupId, checkoutToken }) => {
  if (typeof window === 'undefined' || !sessionId || !pendingSignupId || !checkoutToken) return;
  try {
    window.sessionStorage.setItem(
      SIGNUP_CHECKOUT_STORAGE_KEY,
      JSON.stringify({ sessionId, pendingSignupId, checkoutToken })
    );
  } catch (_error) {
    // Storage can be unavailable in privacy-restricted browsers. Completion
    // still works without it; only signing the tab back in does not.
  }
};

// Only for the checkout session this tab opened, so a link left over from an
// earlier checkout is never sent with a different session_id.
export const getSignupCheckout = (sessionId) => {
  if (typeof window === 'undefined' || !sessionId) return null;
  try {
    const stored = JSON.parse(window.sessionStorage.getItem(SIGNUP_CHECKOUT_STORAGE_KEY));
    if (
      stored?.sessionId !== sessionId ||
      typeof stored.pendingSignupId !== 'string' ||
      typeof stored.checkoutToken !== 'string'
    ) {
      return null;
    }
    return { pendingSignupId: stored.pendingSignupId, checkoutToken: stored.checkoutToken };
  } catch (_error) {
    return null;
  }
};

export const clearSignupCheckout = () => {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.removeItem(SIGNUP_CHECKOUT_STORAGE_KEY);
  } catch (_error) {
    // Storage can be unavailable in privacy-restricted browsers.
  }
};
